import styled from 'styled-components'

export const Overlay = styled.div`
	position: fixed;
	inset: 0;
	background: rgba(0,0,0,0.32);
	z-index: 130;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 32px 20px;
`

export const Dialog = styled.div`
	width: 488px;
	max-width: 100%;
	background: #FFFFFF;
	border-radius: 10px;
	box-shadow: 0 4px 32px -8px rgba(16,24,40,0.10);
	display: flex;
	flex-direction: column;
	max-height: 100%;
`

export const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 16px 20px 12px;
	border-bottom: 1px solid #F5F5F6;

	h2 {
		margin: 0;
		font-size: 18px;
		font-weight: 600;
		color: #101018;
	}

	button {
		background: none;
		border: 0;
		font-size: 20px;
		cursor: pointer;
		line-height: 1;
		color: #3F3F45;
		padding: 4px;
	}
`

export const Body = styled.div`
	padding: 8px 20px 4px;
	overflow: auto;
	flex: 1;
	font-size: 14px;
	line-height: 20px;
	color: #9C9C9F;
`

export const Intro = styled.p`
	margin: 0 0 16px;
`

export const List = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
`

interface ItemProps { selected: boolean }

export const Item = styled.label<ItemProps>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	padding: 12px 12px 12px 0;
	cursor: pointer;
	border-bottom: 1px solid #F5F5F6;
	font-size: 14px;
	color: #101018;

	&:last-child { border-bottom: 0; }

	input { display: none; }

	span.bullet {
		width: 16px;
		height: 16px;
		border-radius: 99px;
		outline: ${p => p.selected ? '2px solid #AF7AD5' : '1.6px solid #E2E2E3'};
		display: flex;
		align-items: center;
		justify-content: center;
		transition: all .18s ease;

		${p => p.selected && `
			border: 2.3px solid white;
			background-color: #AF7AD5;
		`}
	}
`

export const Footer = styled.div`
	padding: 10px 20px 14px;
	display: flex;
	justify-content: flex-end;
	gap: 12px;
	border-top: 1px solid #F5F5F6;

	button {
		height: 38px;
		padding: 6px 20px;
		border-radius: 99px;
		font-size: 14px;
		font-weight: 600;
		cursor: pointer;
		transition: background-color .15s ease, color .15s ease;
	}

	.cancel {
		background: #F5F5F6;
		color: #3F3F45;
		border: 0;

		&:hover { background: #E1E1E1; }
	}
	.reject {
		background: #DD524D;
		color: #FFFFFF;
		border: 0;

		&:hover:not(:disabled) { background: #C94A3A; }
	}
	.reject:disabled { opacity: .5; cursor: not-allowed; }
`

export type { ItemProps }
